import { normalizeAssetIdFormat } from "@repo/types";

export const ONDO_ETHEREUM_CHAIN_ID = 1 as const;

export const ONDO_ETHEREUM_ASSET_ADDRESSES = [
  "0x01b19c68f8a9ee3a480da788ba401cfabdf19b93",
  "0x032dec3372f25c41ea8054b4987a7c4832cdb338",
  "0x03c1ec4ca9dbb168e6db0def827c085999cbffaf",
  "0x04d94914cd1d7ff749efedee764335777225b962",
  "0x050362ab1072cb2ce74d74770e22a3203ad04ee5",
  "0x060505527c83e8bfeb9b4ff08248b82e688800f1",
  "0x0692481c369e2bdc728a69ae31b848343a4567be",
  "0x06954faa913fa14c28eb1b2e459594f22f33f3de",
  "0x070d79021dd7e841123cb0cf554993bf683c511d",
  "0x073e7a0669833d356fa88ca65cc6d454efaaa3c5",
  "0x0752163d221d3d5d4b6e98bd616b22bd2b453964",
  "0x075756f3b6381a79633438faa8964946bf40163d",
  "0x0a00c19246fc41b2524d56c87ec44ce8b30ba0f8",
  "0x0b59fdb1a233a7477ea14061004b9dd776e73cb3",
  "0x0c1f3412a44ff99e40bf14e06e5ea321ae7b3938",
  "0x0c666485b02f7a87d21add7aeb9f5e64975aa490",
  "0x0c802acb21cb2aadb2eb5e5090868e1361b26b69",
  "0x0c8276e4fec072cf7854be69c70f7773d1610857",
  "0x0ce36d199bd6851788e03392568849394cbde722",
  "0x0d1fa4e1e3719945899ef7b02840627df46af44a",
  "0x0d54d4279b9e8c54cd8547c2c75a8ee81a0bcae8",
  "0x0e397938c1aa0680954093495b70a9f5e2249aba",
  "0x0e3d889d5b857c3e6eb361b9c9ae35bb7ddbd254",
  "0x0f8887772262c449793890dcd3bf320308db423b",
  "0x110cae53912c2ed9bf279cd70b3b699e26c79e58",
  "0x1140043f02d8ee34b10eae2e32ae921cda1459ee",
  "0x122940c4c5f9ccfae7fa86455a42d3ec140855ce",
  "0x14c3abf95cb9c93a8b82c1cdcb76d72cb87b2d4c",
  "0x185e5fa1b84f94d46ef2a33052ad39bd5f326fd8",
  "0x193fdf644451cc394b28b9cec2f5d32e2b4de515",
  "0x1b468d5535ed7c19ce42f0073db7fdf441028131",
  "0x1b8d3e59b31981385c066ee0916ec964628ff1f9",
  "0x1c174711f3fd63c4165d6f296b3eb19d17fde94a",
  "0x1c5fa55eade69ae98571059332520f73733c2d82",
  "0x1cb673005fc58447d881486919c14d8e7c741bb1",
  "0x1f5fc5c3c8b0f15c7e21af623936ff2b210b6415",
  "0x1fb5a8dcd70be750a97eaf8a47bbe74ab7d3183e",
  "0x1fe2126bc05e4bb0468c4a198e930c889e1054a3",
  "0x20224080ad516769723c9a4a18325fc4e8c9ab5d",
  "0x20e113e9235df6a2a9bfc6f244c2ccc380c8f546",
  "0x219a1b27baa08d72fac836665a3b752f3c9acbbc",
  "0x21be23f5bf87a749670c088f6dee26760f1ab80f",
  "0x21deafd91116fce9fe87c8f15bde03f99a309b72",
  "0x224b381cfae8ccaf2e4d32d827467c2331ce04be",
  "0x241958c86c7744d15d5f6314ba1ea4c81dda2896",
  "0x244efb92f76a57da49b5f71045dce3e546e13106",
  "0x24e5bc45d5b6cef6f38989ac33df587a3fc850cf",
  "0x25018520138bbab60684ad7983d4432e8b8e926b",
  "0x25d3f236b2d61656eebdea86ac6d42168e340011",
  "0x2691b13fca1e02322685b9554b5ae0f5f3f05c55",
  "0x28151f5888833d3d767c4d6945a0ee50d1b193e3",
  "0x2816169a49953c548bfeb3948dcf05c4a0e4657d",
  "0x2b7727076b9c9b1834a2f95b81f12eedd30db9f1",
  "0x2bc7ff0c5da9f1a4a51f96e77c5b0f7165dc06d2",
  "0x2ca12a3f9635fd69c21580def14f25c210ca9612",
  "0x2d1f7226bd1f780af6b9a49dcc0ae00e8df4bdee",
  "0x2dd57b497c777d9825a5902114be81df98ede958",
  "0x2ddc2391cc89e3e716a938f089ae755174cfdf1f",
  "0x2df38ca485d01fc15e4fd85847ed26b7ef871c1c",
  "0x2f2e4b09b99fbf018f600e031aafd9da6347cc75",
  "0x318dcb4f07c3e6ccecc12a252100fb3bf76eeb02",
  "0x32d7c413fd3477e86b8ec6b0bb8f3ac510eafaae",
  "0x33483a58079b4225b10e57958ca28ad7b9cdbaf7",
  "0x334ccd8df4013bac99af8c5c61d3605b315302a0",
  "0x3361a73262199873b74d6835760a59b8817fa592",
  "0x339ce23a355ed6d513dd3e1462975c4ecd86823a",
  "0x33ac34da58168de69ce74a66fbad81a88f974bd5",
  "0x34bfdff25f0fda6d3ad0c33f1e06c0d40bd68885",
  "0x3632dea96a953c11dac2f00b4a05a32cd1063fae",
  "0x36e3b8d9aad0e51ac08e56a75a8f6005bf68535b",
  "0x3807562a482b824c08a564dfefcc471806d3e00a",
  "0x3859385363f7bb4dfe42811ccf3f294fcd41dd1d",
  "0x398f7f759380f3d309b9fc0e6cb3d36e0d67818d",
  "0x39930751d4569f7dd45d1ba46e82cd3680ec2e0a",
  "0x3a16af9ef328d087cc781053a2a2a27549ae6768",
  "0x3cafdbfe682aec17d5ace2f97a2f3ab3dcf6a4a9",
  "0x3ce219d498d807317f840f4cb0f03fa27dd65046",
  "0x3d07c3161f355cb9e5b524bef8d113c96e0263ab",
  "0x3d1cf8692a6f2fc9048a9cc1a06abf77f3465f0a",
  "0x4111b60bc87f2bd1e81e783e271d7f0ec6ee088b",
  "0x41765f0fcddc276309195166c7a62ae522fa09ef",
  "0x423a63dfe8d82cd9c6568c92210aa537d8ef6885",
  "0x423d42e505e64f99b6e277eb7ed324cc5606f139",
  "0x42d6e274b8631e5289a8f853e8d1a7baeff3c8d1",
  "0x44e89d34601b8d0155e16634d2553ef7f54dbab2",
  "0x4604b0b581269843ac7a6b70a5fc019e7762e511",
  "0x46c0a02a877c1412cb32b57028b2f771c0364a7e",
  "0x4ad2118da8a65eaa81402a3d583fef6ee76bdf3f",
  "0x4c82c8cd9a218612dce60b156b73a36705645e3b",
  "0x4d21affd27183b07335935f81a5c26b6a5a15355",
  "0x4efd92f372898b57f292de69fce377dd7d912bdd",
  "0x4f0ca3df1c2e6b943cf82e649d576ffe7b2fabcf",
  "0x4f3b49ac895a29c0908c57538932967cdc8e3c80",
  "0x510dd21055188eda378714de3bb5591ffa0cc468",
  "0x54021fde36b7c4c4f9c35b02fb9a153ed8f5938a",
  "0x54c1ff361b402f66c13107421e6a431c3375ef24",
  "0x55720ef5b023fd043ae5f8d2e526030207978950",
  "0x57270d35a840bc5c094da6fbeca033fb71ea6ab0",
  "0x576e9ca70e3a040c00d8139b0665a2b7b7b64844",
  "0x57b392146848c6321bb2a3d4358df1bdeacdc62a",
  "0x58a2edf0169ede82904e47a0e2a3a4008edebb60",
  "0x58fc9d573ea773ef9a25c3de66f990b87ee5f50e",
  "0x590f21186489ca1612f49a4b1ff5c66acd6796a9",
  "0x592643a667633bca51cb2387c98b6de6ce549a45",
  "0x59644165402b611b350645555b50afb581c71eb2",
  "0x5bcd8195e3ef58f677aef9ebc276b5087c027050",
  "0x5bf1b2a808598c0ef4af1673a5457d86fe6d7b3d",
  "0x5c424b9b60383fce7fe7069d2a2b1047bcd04a73",
  "0x5cb95099a2c7e3c8187fbca6efe5ba222b5ba820",
  "0x5ce215d9c37a195df88e294a06b8396c296b4e15",
  "0x5d1a9a9b118ff19721e0111f094f2360b6ef7a2f",
  "0x60808f2a0d035e16f57e9043842bd1bfbda24fa2",
  "0x625fb557cad6d4638dae420626f3f08a485b43a8",
  "0x62ca254a363dc3c748e7e955c20447ab5bf06ff7",
  "0x66908813cd7676269494b2c6f6dbab8b4f9e95df",
  "0x67c5902f5210f62f37157cd9c735c693164c1378",
  "0x68622855dcf14ced1b0cc2a69cc34843708e2e0f",
  "0x691b126cf619707ed5d16cab1b27c000aa8de300",
  "0x6be935eadc71c49c414b1175985946ee40365c67",
  "0x6cc0afd51ce4cb6920b775f3d6376ab82b9a93bb",
  "0x6cc41275ef02b4eeccc04fc4424849a96f3272aa",
  "0x7042a8ffc7c7049684bfbc2fcb41b72380755a43",
  "0x70b4082f4e3f9067db9a2aa7520c77719e8626ee",
  "0x70ec0f5b23404c0cd6f29ce88f4af00a0b0d895d",
  "0x71d24baeb0a033ec5f90ff65c4210545af378d97",
  "0x71e2400cf1cb83204f33794ed326636a71a9aafc",
  "0x73d2ccee12c120e7da265a2de9d9f952a0101b4f",
  "0x74a03d741226f738098c35da8188e57aca50d146",
  "0x74c8f41f57948bfd8aa0d48c882d69d12d1cc579",
  "0x75846a2b2eeee6575ac775f9984be54fd1d08189",
  "0x77a1a02e4a888ada8620b93c30de8a41e621126c",
  "0x7aa59a63d1d0c435a08bc96e11bef2e95ab66c40",
  "0x7c488cfc874ca9f34e7bdbd0410c27ce6d6af5f9",
  "0x7c7378143a9c8839e0502e2178f058f46c6ea504",
  "0x7dbd435aa4ecab5471cfcef4527a022fef0b7e1c",
  "0x7e08ce07aca80cefe61ebbfa0cedfe5c7b07edb9",
  "0x818234860a647d480b9bbcc9a47a23889f2ec900",
  "0x81eb954936a7062d1758fc0e6e3b88d42d9c361c",
  "0x82106347ddbb23ce44cf4ce4053ef1adf8b9323b",
  "0x84328d8b85019fdcecf4c82fbe076bf350fc0cab",
  "0x84e8f1b9b40dd1832925702459d12ffb14d97bf3",
  "0x858e985126543b5a066c4e8a5dab0249c1d683f7",
  "0x88703c1e71f44a2d329c99e8e112f7a4e7dd6312",
  "0x8a23c6baadb88512b30475c83df6a63881e33e1e",
  "0x8ac6ad49b3344024834f373f3ca491f22ceb952e",
  "0x8bcf9012f4b0c1c3d359edb7133c294f82f80790",
  "0x8ce34f749796f82a6990ffa2d80622ef75ca7ad5",
  "0x8cefd49b703de9c0486d9bf6cb559f0895268ee8",
  "0x8d05432c2786e3f93f1a9a62b9572dbf54f3ea06",
  "0x8de5d49725550f7b318b2fa0f1b1f118e98e8d0f",
  "0x8e6a5338eac4b6fe8d51a7653fad3b9da755eea6",
  "0x8e82a0d7347329703fb6c6a745b1c2b3abb1658c",
  "0x8f3e41b378ae010c46d255f36bfc1d303b52dceb",
  "0x908266c1192628371cff7ad2f5eba4de061a0ac5",
  "0x966db065199a3edea2228c6e5eb6ac49ff251acc",
  "0x980a1001ee94e54142b231f44c7ca7c9df71fbe1",
  "0x98284fbc11edd7540e29b896a49817bbe52ddcbd",
  "0x992651bfeb9a0dcc4457610e284ba66d86489d4d",
  "0x998f02a9e343ef6e3e6f28700d5a20f839fd74e6",
  "0x99aa107e55250a9fe52bb4b5541a59239eb6d974",
  "0x9b56f5ed5a94ae3266b7ff21953e6626f94008f1",
  "0x9cfa08002d606e638fe91941be725e1b970b84a6",
  "0x9d4c6ad12b55e4645b585209f90cc26614061e91",
  "0x9dcf7f739b8c0270e2fc0cc8d0dabe355a150dba",
  "0x9ddb2524782684942fad28b44e76552cb7f3f548",
  "0x9ebd34d99cc3a45b39cafc14ad7994263fa2be56",
  "0x9f2e3eb0160117c56b07652fe66a08a48b5bd7b5",
  "0xa043fdc5a6e2e381e3532d5a97404b82fb7a0af8",
  "0xa29dc2102dfc2a0a4a5dcb84af984315567c9858",
  "0xa2c1c0b4683a871187d4565eb63abf9aef5947ee",
  "0xa2ec76139028f279a1c790d323c57cc4158098d6",
  "0xa45cd7ac9865b9539166ebaf2abc362df4736580",
  "0xa52b2d6ca1cd9b1e8b931645428380c340caef9a",
  "0xa637ae510cb50e61236a89ac480b93b8c3bccc46",
  "0xa6cdb19b22b03e03ea89e133a8a46adc3017aa6d",
  "0xa9431d354cfad3c6b76e50f0e73b43d48be80cd0",
  "0xab02fc332e9278ebcbbc6b4a8038050c01d15f69",
  "0xaba9ae731aad63335c604e5f6e6a5db2e05f549d",
  "0xac37c20c1d0e5285035e056101a64e263ff94a41",
  "0xace8e719899f6e91831b18ae746c9a965c2119f1",
  "0xacf3fecaa787f268351a86409c3bd3b96ef924fb",
  "0xb035c3d5083bdc80074f380aebc9fcb68aba0a28",
  "0xb22d83e228c4266075ec75c32acc3bc059b6f248",
  "0xb2924278cc92e60db9b673d6a311d7a331dd703d",
  "0xb40afd1d55ea61fc1a6fbe093b817b673c8e78d7",
  "0xb51db25c920c16f2865c37011c3eec91db946b07",
  "0xb53894f82a6b2d3b7365f24932b5bde1c5fb51ff",
  "0xb6e362a39db703f0f7cf582c9fc043a51624e53d",
  "0xb812837b81a3a6b81d7cd74cfb19a7f2784555e5",
  "0xba47214edd2bb43099611b208f75e4b42fdcfedc",
  "0xbb8774fb97436d23d74c1b882e8e9a69322cfd31",
  "0xbc843b147db4c7e00721d76037b8b92e13afe13f",
  "0xbca31049ab4782f0ffa9cffcb2cf48e8d6de4fb8",
  "0xbd660e96d45e7c175512d1ed0ccc119cb980b81a",
  "0xbe8eb7b51a08f9d52bb6c8c7eca699f0f89bfc02",
  "0xbf54eb503bb350583d11f4348086dc3608fa245c",
  "0xbfe6e76a2fe099392064fbb3e868558c82beb917",
  "0xc017c622cd05698580e2decd0f97d4a17dab70f9",
  "0xc2dbfe026f17e7bbc17a9e41f9b8d69531887d47",
  "0xc3d93b45249e8e06cfeb01d25a96337e8893265d",
  "0xc46e7ef70d7cf8c17863a6b0b9be2af6a4c41abe",
  "0xc4e6e80295154d3968519851f73f8dc1a227286f",
  "0xc53d2e7321ab83b28af2360559aa303676a23f98",
  "0xc80c91bc6215e1333ea98314b8671d6e26c58470",
  "0xc95c9e3fa311664b5e744b3c2716547bec2ba7da",
  "0xca468554e5c0423ee858fe3942c9568c51fcaa79",
  "0xcabd955322dfbf94c084929ac5e9eca3feb5556f",
  "0xcac9aafb2cf51645ae1ab4fb1f35f07d42437f80",
  "0xcc40965d3621362c3ee1dd946ba98d6a708ea86b",
  "0xccae8843e26259278c200c6506f6e5a3bdd524cd",
  "0xcdd60d15125bf3362b6838d2506b0fa33bc1a515",
  "0xd08ddb436e731f32455fe302723ee0fd2e9e8706",
  "0xd0a265a32d0211a7f61f11de014b854f7ce716f8",
  "0xd4c6cce0cadf2fe4c0af9ee6777989efd8fb7670",
  "0xd5c5b2883735fa9b658dd52e2fcc8d7c0f1a42ce",
  "0xd8e26fcc879b30cb0a0b543925a2b3500f074d81",
  "0xd904bcf89b7cedf5c89f9df7e829191d695f847e",
  "0xda81da76070a7377eaeeb2978f0e13c5d57fadb7",
  "0xdb57d9c14e357fc01e49035a808779df41e9b4e2",
  "0xdc8a7db05ea704227d56f5d4a4b77a2d1bba29c0",
  "0xdd0e1e6162666a210905ffe8d368661b313c00e9",
  "0xdeb3c23f93349229823a006657cfe1a6552b6340",
  "0xdeb6b89088ca9b7d7756087c8a0f7c6df46f319c",
  "0xe3419710c1f77d44b4dab02316d3f048818c4e59",
  "0xe4babaa960ba7d37860f3fe00d7b95d3868e8edc",
  "0xe51ba774ebf6392c45bf1d9e6b334d07992460d3",
  "0xe5b26ba77e6a4d79a7c54a5296d81254269d9700",
  "0xe668e08a6f5792cef0e63e9d98524968fdb5882f",
  "0xe737f948bdfe3beae9423292853ec0579173cebb",
  "0xe7ee911172bdd557b9ab6be7701f86bbc8fd772e",
  "0xe8b09e8175aecb35a171fa059647434fe47f114c",
  "0xeaa2287290544ed9f481012aa348619a4d2f9e51",
  "0xeb08d539be0f6a6c90ea24276196e348f5688a02",
  "0xec169f9ac2161723a2d4febd9748bb529d6c12b5",
  "0xed3618bb8778f8ebbe2f241da532227591771d04",
  "0xee2542f442a5ed8008e2fe3590e14f90db69f70d",
  "0xeedc48205852e9d83ea5ca92fa8656597788601f",
  "0xf0372e226553af4f343b44111a789f87a9fa427a",
  "0xf042cfa86cf1d598a75bdb55c3507a1f39f9493b",
  "0xf05ad9840924ea6f977ebccb3b1da87e31dcd0b4",
  "0xf1573edddb75bf7ce165f142a17ed6b5e7f5aa13",
  "0xf15fbc1349ab99abad63db3f9a510bf413be3bef",
  "0xf1883461ec7bd883a3668749c5cf5f351080d059",
  "0xf192957ae52db3eb088654403cc2eded014ae556",
  "0xf3e4872e6a4cf365888d93b6146a2baa7348f1a4",
  "0xf404e5f887dbd5508e16a1198fcdd5de1a4296b8",
  "0xf46ba88694cd7933ca28be84ee787ad5732e856b",
  "0xf6b1117ec07684d3958cad8beb1b302bfd21103f",
  "0xf719b02079e0faa5450392da2d3e11a1e5b0eadb",
  "0xf72936fa8afc808c99eb76e620a98ddc6a7a53d1",
  "0xf98ec282300892b3518b5cb996012b18d9b7d435",
  "0xfa690b2b6f6b4da518035f1d0aa8b968c23341bb",
  "0xfa9f0bf8baa9a3d5e0a8e5c0aeaf186acabef63d",
  "0xfb82561a955bf59b9263301126af490d3799e231",
  "0xfc003a764a7b5054cc6fdb6b511f35dec8022751",
  "0xfd50fc4e3686a8da814c5c3d6121d8ab98a537f0",
  "0xfda09936dbd717368de0835ba441d9e62069d36f",
  "0xfdb46864a7c476f0914c5e82cded3364a9f56f8a",
  "0xfdfdf5db2f4a72cb754ffa8896ea012dc2cc0f5e",
  "0xfe4ec50e0413148021d2f50d114cc44de6ffbf23",
  "0xfedc5f4a6c38211c1338aa411018dfaf26612c08",
  "0xfeff7a377a86462f5a2a872009722c154707f09e",
  "0xff7cf16aa2ffc463b996db2f7b7cf0130336899d",
] as const satisfies readonly `0x${string}`[];

export const ONDO_ETHEREUM_ASSET_IDS = ONDO_ETHEREUM_ASSET_ADDRESSES.map(
  (address) =>
    normalizeAssetIdFormat(`${address}:${ONDO_ETHEREUM_CHAIN_ID}`),
);
